import { FunctionComponent, useEffect } from 'react';
import { FacebookMessengerShareButton, FacebookShareButton, LinkedinShareButton, WhatsappShareButton } from 'react-share';
import { toast } from 'react-toastify';
import getConfig from 'next/config';
import { useRouter } from 'next/router';
import classnames from 'classnames';

import { Locales } from 'types/locale';

import { isBrowser } from 'utils/browser';
import { select as selectLocale } from 'utils/locale';
import Tracking, { SmEventDescriptons, SmEventTypes } from 'services/Tracking';

import Button, { ButtonIconPositions, ButtonIconTypes, ButtonLayouts, ButtonStyles, ButtonVariants } from 'components/layout/Button';
import ToastSuccessContainer from 'components/layout/ToastSuccessContainer';
import Tooltip from 'components/layout/Tooltip';

import { Props } from './index';
import StyledComponent from './styles';

const PublicLayoutControlsShareButton: FunctionComponent<Props> = ({ disabled, actions, state, iconOnly }) => {
    const { publicRuntimeConfig } = getConfig();
    const router = useRouter();

    const shareUrl = publicRuntimeConfig.APP_URL + router.asPath;
    const isJobPage = shareUrl.includes('/oferta-pracy/') && state?.user?.email && isBrowser();

    const translations = selectLocale({
        [Locales.Pl]: require('./locales/pl.json'),
    });

    useEffect(() => {
        actions.profileGet();
    }, []);

    return (
        <StyledComponent className={
            classnames(
                'public-layout-controls-share-button',
                {
                    'disabled': disabled,
                }
            )
        }
        >
            <Tooltip
                name="share-tooltip"
                reactTooltipProps={{
                    place: 'top',
                    type: 'light',
                    border: true,
                    borderColor: '#000000',
                    clickable: true,
                    offset: {
                        top: -10,
                    },
                }}
                text={(
                    <div onClick={() => isJobPage && Tracking.salesManago(
                        state?.user?.email,
                        SmEventTypes.Other,
                        SmEventDescriptons.SharedOffer,
                        window.location?.toString(),
                    )}
                    >
                        <div className="tooltip-share-icons">
                            <FacebookShareButton
                                url={shareUrl}
                            >
                                <img
                                    className="icon"
                                    src="/images/share-icons/fb.svg"
                                    loading="lazy"
                                    alt="facebook"
                                />
                            </FacebookShareButton>
                            <LinkedinShareButton url={shareUrl}>
                                <img
                                    className="icon"
                                    src="/images/share-icons/li.jpg"
                                    loading="lazy"
                                    alt="linkedin"
                                />
                            </LinkedinShareButton>
                            <FacebookMessengerShareButton
                                url={shareUrl}
                                appId={publicRuntimeConfig.FACEBOOK_APP_ID}
                            >
                                <img
                                    className="icon"
                                    src="/images/share-icons/messenger.svg"
                                    loading="lazy"
                                    alt="facebook messenger"
                                />
                            </FacebookMessengerShareButton>
                            <WhatsappShareButton url={shareUrl}>
                                <img
                                    className="icon"
                                    src="/images/share-icons/whatsapp.jpg"
                                    loading="lazy"
                                    alt="facebook"
                                />
                            </WhatsappShareButton>
                            <button
                                className='copy-link'
                                onClick={() => navigator.clipboard.writeText(shareUrl).then(() =>
                                    toast.success(
                                        <ToastSuccessContainer
                                            text={translations?.copyLink}
                                        />, {
                                            closeButton: false,
                                        })
                                )}
                            >
                                <img
                                    className="icon"
                                    src="/images/share-icons/link.svg"
                                    loading="lazy"
                                    alt="facebook"
                                />
                            </button>
                        </div>
                    </div>
                )}
            >
                <Button
                    className="button"
                    style={ButtonStyles.Secondary}
                    variant={ButtonVariants.Outline}
                    layout={ButtonLayouts.Wide}
                    icon={{
                        type: ButtonIconTypes.Image,
                        position: ButtonIconPositions.Before,
                        alt: 'udostępnij',
                        value: '/images/job/job/share.svg',
                        hover: '/images/job/job/share.svg',
                        width: 18,
                        height: 20
                    }}
                    ariaLabel={iconOnly ? 'Udostępnij' : undefined}
                >
                    {iconOnly ? '' : 'Udostępnij'}
                </Button>
            </Tooltip>
        </StyledComponent>
    );
};

export default PublicLayoutControlsShareButton;